import { STORE_HYDRATE } from 'brighteon/actions/store';
import { APP_LAYOUT_CHANGE } from 'brighteon/actions/app';
import { Map as ImmutableMap } from 'immutable';
import { layoutFromWindow } from 'brighteon/is_mobile';

const initialState = ImmutableMap({
  streaming_api_base_url: null,
  access_token: null,
  layout: layoutFromWindow(),
});

export default function meta(state = initialState, action) {
  switch (action.type) {
  case STORE_HYDRATE:
    return state.merge(action.state.get('meta'));
  case APP_LAYOUT_CHANGE:
    return state.set('layout', action.layout);
  default:
    return state;
  }
};
